import { Checkbox, Slider } from '@progress/kendo-react-inputs';
import SettingsSubSection from '../../../../../components/common/SettingsSubSection';
import ColorPickerWithDefault from '../../../../components/inputs/ColorPickerWithDefault';
import { useViewCheckboxValue, useViewColorValue, useViewSliderValue } from '../../hooks/view-forms';

export function NavaidsSettings() {
    const fontSize = useViewSliderValue((x) => x.staticData.navaids.settings.fontSize);
    const drawRings = useViewCheckboxValue((x) => x.staticData.navaids.rings.draw);
    const drawTerminal = useViewCheckboxValue((x) => x.staticData.navaids.rings.drawTerminal);
    const drawLowAltitude = useViewCheckboxValue((x) => x.staticData.navaids.rings.drawLowAltitude);
    const drawHighAltitude = useViewCheckboxValue((x) => x.staticData.navaids.rings.drawHighAltitude);
    const drawUnrestricted = useViewCheckboxValue((x) => x.staticData.navaids.rings.drawUnrestricted);
    const fillColor = useViewColorValue((x) => x.staticData.navaids.rings.fillColor);
    const lineColor = useViewColorValue((x) => x.staticData.navaids.rings.lineColor);

    return (
        <div className="px-3 py-2" style={{ minWidth: '300px' }}>
            <SettingsSubSection title="Navaid details">
                <div>
                    <div>Font size: {fontSize.value}</div>
                    <Slider
                        min={4}
                        max={20}
                        step={1}
                        largeStep={1}
                        className="w-100"
                        value={fontSize.value}
                        onChange={(e) => fontSize.onChange?.({ ...e, value: Math.round(e.value) })}
                    />
                </div>
            </SettingsSubSection>
            <SettingsSubSection title="Rings">
                <div className="d-flex flex-column gap-1">
                    <Checkbox {...drawRings} label="Draw power level rings" />
                    <div className="px-2 d-flex flex-column gap-1">
                        <Checkbox {...drawTerminal} label="Terminal (25NM)" />
                        <Checkbox {...drawLowAltitude} label="Low altitude (40NM)" />
                        <Checkbox {...drawHighAltitude} label="High altitude (130NM)" />
                        <Checkbox {...drawUnrestricted} label="Unrestricted (130NM)" />
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <div>Fill</div>
                        <ColorPickerWithDefault {...fillColor} id="navaid-rings-fill" defaultColor="rgba(0,0,255,0.2)" />
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <div>Line color</div>
                        <ColorPickerWithDefault {...lineColor} id="navaid-rings-line" defaultColor="rgba(0,0,255,0.5)" />
                    </div>
                </div>
            </SettingsSubSection>
        </div>
    );
}
